import { render } from "./PassBlocking.vue?vue&type=template&id=bbeb4a96"
import script from "./PassBlocking.vue?vue&type=script&lang=js"
export * from "./PassBlocking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__